module.exports = __webpack_public_path__ + "static/loading-cd1cee719bab8768f6d3760f7f3d830d.mp4";